var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1886 281L1886 309",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1886.5,
    cy: 276.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1881.99 276.19C1881.99 272.283 1885.29 269.117 1889.36 269.117C1889.94 269.117 1890.51 269.184 1891.06 269.308C1889.74 268.48 1888.19 268 1886.52 268C1881.81 268 1878 271.806 1878 276.5C1878 281.194 1881.81 285 1886.52 285C1888.81 285 1890.89 284.093 1892.43 282.62C1891.49 283.032 1890.45 283.263 1889.36 283.263C1885.29 283.263 1881.99 280.096 1881.99 276.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1895.4 275.6L1895.37 273.146L1893.54 274.719L1891.3 274.056L1892.11 276.337L1890.77 278.381L1893.1 278.218L1894.5 280.144L1895.13 277.763L1897.34 276.909L1895.4 275.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.e5fd3612e6d03cd7c15efabc22d0823b.svg";
export { ForwardRef as ReactComponent };